<template>
  <div class="flex flex-col gap-1">
    <LabelDefault v-if="label">
      {{ label }}
    </LabelDefault>
    <div class="flex items-center justify-start flex-wrap gap-2">
      <TagDefault
        v-for="tag in tagList"
        :key="tag.id"
        class="cursor-pointer"
        :id="`tag-${tag.id}`"
        :tag="tag"
        type="long"
        :selected="_.includes(modelValue, tag.id)"
        @click="updateTag(tag)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import * as _ from 'lodash-es'
import { toRefs } from 'vue'

import LabelDefault from '@/common/components/atoms/LabelDefault.vue'
import TagDefault from '@/common/components/atoms/TagDefault.vue'

import { GuestTagRead, ReservationTagRead } from '@generated/types'

type Tag = ReservationTagRead | GuestTagRead
type TagId = Tag['id']

const emit = defineEmits<{
  // eslint-disable-next-line no-unused-vars
  (e: 'update:modelValue', tagIds: TagId[])
}>()

const props = defineProps<{
  tagList: Tag[]
  modelValue: TagId[]
  label?: string
}>()
const { tagList, modelValue, label } = toRefs(props)

const updateTag = (tag: Tag) => {
  const tagIds: TagId[] = _.includes(modelValue.value, tag.id)
    ? _.without(modelValue.value, tag.id)
    : [...modelValue.value, tag.id]

  emit('update:modelValue', tagIds)
}
</script>
